const { OverlayTrigger: OverlayTriggerAS } = require('react-bootstrap');

const OverlayTrigger = (props) => {
  return (
    <OverlayTriggerAS
      {...props}
      placement={props.placement || 'auto'}
    />
  );
};
export default OverlayTrigger;
